import PropTypes from "prop-types";
import React from "react";

import {
  Image,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ViewPropTypes
} from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class PatientField extends React.Component {
  static defaultProps = {
    editable: false,
    onEditPress: () => {}
  };

  static propTypes = {
    containerStyle: ViewPropTypes.style,
    editable: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onEditPress: PropTypes.func,
    value: PropTypes.string.isRequired
  };

  render() {
    const {
      containerStyle,
      editable,
      label,
      onEditPress,
      themeColors,
      value
    } = this.props;

    const content = (
      <View style={[styles.container, containerStyle]}>
        <Text style={[styles.label, { color: themeColors.primary }]}>
          {label.toUpperCase()}
        </Text>
        <View style={{ alignItems: "center", flexDirection: "row" }}>
          <Text style={styles.value}>{value}</Text>

          {editable && (
            <Image
              source={require("../assets/icons/baseline_edit_black_18dp.png")}
              style={{ marginStart: 10 }}
            />
          )}
        </View>
      </View>
    );

    if (editable) {
      return (
        <TouchableOpacity onPress={onEditPress} style={containerStyle}>
          {content}
        </TouchableOpacity>
      );
    } else {
      return content;
    }
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 5
  },
  label: {
    fontSize: 16,

    ...fonts.bold
  },
  value: {
    color: staticColors.cavernous,
    fontSize: 16,

    ...fonts.bold
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(PatientField);
